import type { IconProps } from './types';

export const ArrowNarrowRightIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M0.75 12H21.8438" stroke={color} strokeWidth="1.5" />
      <path d="M14.3438 19.5L21.8438 12L14.3438 4.5" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
